module.exports = __webpack_public_path__ + "img/fi-rr-cloud-download.859af1f8.svg";